import {UrlParamsStorageConfig} from 'interfaces/common/components/configuration/urlparams/urlParamsStorageConfig';

import {getGemSettingsFeature} from '../config/getGemSettingsFeature';
import {GemSettings} from '../config/interface';

import {buildParams} from './buildParams';
import {saveToStorage} from './saveToStorage';

export const initURLParametersStorage = (gemSettings: GemSettings) => {
    // store the URL parameters (or parameters behind the #) into the session storage.
    const urlParamsStorageConfig = getGemSettingsFeature<UrlParamsStorageConfig>(gemSettings, 'url-params');
    if (urlParamsStorageConfig) {
        const params = buildParams(
            urlParamsStorageConfig.storeAllURLParams ?? false,
            urlParamsStorageConfig.parameters ?? [],
            gemSettings,
            urlParamsStorageConfig.storeURLFragment,
        );
        saveToStorage(params);
    }
};
